import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, ScrollText } from "lucide-react";
import { API_BASE, formatApiError } from "../../components/AuthContext";
import EngagementSignView, { fmtAUD } from "../../components/EngagementSignView";

const STATUS_BG = { signed: "var(--moss)", sent: "var(--accent)", expired: "var(--ink-3)" };

export function PortalEngagementsList() {
  const [rows, setRows] = useState(null);
  useEffect(() => { axios.get(`${API_BASE}/portal/engagements`).then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  return (
    <div className="px-10 py-12 max-w-[1000px]" data-testid="portal-engagements-list">
      <div className="overline mb-2 text-[var(--accent)]">From your accountant</div>
      <h1 className="font-heading text-4xl sm:text-5xl leading-tight mb-8" style={{ fontWeight: 500 }}>
        <em className="italic" style={{ color: "var(--accent)" }}>Engagement</em> letters
      </h1>
      {rows === null ? <div className="text-[var(--ink-3)]">Loading…</div> : rows.length === 0 ? (
        <div className="card p-10 text-center">
          <ScrollText size={28} className="mx-auto mb-3 text-[var(--ink-3)]" />
          <div className="text-[var(--ink-3)] text-sm">No engagement letters yet.</div>
        </div>
      ) : (
        <div className="space-y-3">
          {rows.map((e) => (
            <Link key={e.engagement_id} to={`/portal/engagements/${e.engagement_id}`} className="card p-5 flex items-center justify-between hover:border-[var(--ink)] transition"
              data-testid={`portal-engagement-row-${e.engagement_id}`}>
              <div>
                <div className="font-heading text-lg" style={{ fontWeight: 500 }}>Engagement letter · {e.financial_year}</div>
                <div className="text-[12px] text-[var(--ink-3)] font-mono mt-1">Total {fmtAUD(e.total)}</div>
              </div>
              <span className="badge" style={{ background: STATUS_BG[e.status], color: "var(--paper)" }}>
                {e.status === "sent" ? "Needs signature" : e.status}
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export function PortalEngagementSign() {
  const { id } = useParams();
  const [eng, setEng] = useState(null);
  useEffect(() => { axios.get(`${API_BASE}/portal/engagements/${id}`).then((r) => setEng(r.data)).catch((e) => toast.error(formatApiError(e))); }, [id]);
  const sign = async (body) => {
    try { const r = await axios.post(`${API_BASE}/portal/engagements/${id}/sign`, body); setEng(r.data); }
    catch (e) { toast.error(formatApiError(e)); throw e; }
  };
  return (
    <div className="px-10 py-12 max-w-[820px]" data-testid="portal-engagement-page">
      <Link to="/portal/engagements" className="inline-flex items-center gap-1 text-[12px] text-[var(--ink-3)] hover:text-[var(--ink)] mb-4">
        <ArrowLeft size={12} /> Back to engagement letters
      </Link>
      {eng ? <EngagementSignView eng={eng} onSign={sign} /> : <div className="text-[var(--ink-3)]">Loading…</div>}
    </div>
  );
}
